import Keycloak from 'keycloak-js';
import { keycloakConfig } from '../../config';

const minTokenValidity = 10;
let keycloakInstance: Keycloak | null = null;

export function setupKeycloakInstance(): Keycloak {
    if (!keycloakInstance) {
        keycloakInstance = new Keycloak(keycloakConfig);
    }
    keycloakInstance.onAuthError = (errorData) => { console.log(errorData) }
    return keycloakInstance;
}

export function getKeycloak(): Keycloak {
    if (!keycloakInstance) {
        throw new Error('Keycloak not initialized. Call initKeycloak first.');
    }
    return keycloakInstance;
}

export async function getAccessToken(): Promise<string | undefined> {
    if (!keycloakInstance){
        return Promise.resolve(undefined);
    }

    try
    {
        //If the token expires within `minValidity` seconds, the token is refreshed.
        await keycloakInstance.updateToken(minTokenValidity);    
        return Promise.resolve(keycloakInstance.token);
        
    } catch(error) {
        console.log(`Error refreshing token: ${error}`);
        const url = await keycloakInstance.createLoginUrl();
        window.location.replace(url);
        return Promise.resolve(undefined)
    }
}